<template>
<b-container class="py-6">
  <b-row>
    <b-col class="text-center">
      <slot name="icon">
	<b-img :src="require('../assets/trinapp_files.png')" style="height: 114px;" />
      </slot>
    </b-col>
  </b-row>
  <b-row>
    <b-col class="text-center">
      <h1 class="mt-4">
	<slot name="header">Two steps to get started</slot>
      </h1>
      <div class="text-left d-inline-block mx-auto py-4">
	<slot name="list">
	  <ol>
	    <li>Get Started</li>
	    <li>Upload Some Files</li>
	  </ol>
	</slot>
      </div>
    </b-col>
  </b-row>
  <b-row>
    <b-col class="text-center">
      <div class="text-left d-inline-block mx-auto pb-5" style="max-width: 660px;">
	<slot name="description">
	  <p class="mb-0">You are done.</p> 
	  <p class="mb-0">Trinity will place your information into the one-world model where she can do her magic to help you.</p>
	  <p class="mb-0">You can get your work done faster by seeing new relationships and finding your files with ease.</p>
	  <p class="mb-0">You can Securely collaborate with your friends and colleagues</p>
	</slot>
      </div>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
export default {
    name: "Layout07",
    components: {
	FontAwesomeIcon
    },
    data () {
	return {
            faCheck
        }
    },
    props: {
	checkColor: String
    }
}
</script>

<style scoped>
li {
font-size: 1.34rem;
}
</style>
